import { inject, observer } from "mobx-react";
import DashboardComponent from "../../components/UserManagement/Dashboard/DashboardComponent";

const Dashboard = inject('userStore','sharedStore','loginStore')(observer(DashboardComponent));

export default Dashboard;